import { useEffect, useState } from 'react';

import { Topology, eventingApi } from '../../../../../services/eventingApi';
import { ApiResource, useApiResource } from './useApiResource';

const REFRESH_MS = 120000;

export interface TopologyResource extends ApiResource<Topology> {
  loadedAt: string | null;
}

export const useTopology = (): TopologyResource => {
  const resource = useApiResource(() => eventingApi.getTopology(), []);
  const [loadedAt, setLoadedAt] = useState<string | null>(null);
  const { reload, data } = resource;

  useEffect(() => {
    const timer = window.setInterval(() => {
      if (document.visibilityState === 'visible') reload();
    }, REFRESH_MS);
    return () => window.clearInterval(timer);
  }, [reload]);

  useEffect(() => {
    if (data) setLoadedAt(new Date().toISOString());
  }, [data]);

  return { ...resource, loadedAt };
};
